var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',{staticClass:"iq-footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"}),_c('div',{staticClass:"col-lg-6 text-right"},[_vm._v(" Copyright 2022 "),_c('a',{attrs:{"href":"https://aljayplantingdreams.com"}},[_vm._v("Aljay Solutions")]),_vm._v(" All Rights Reserved. ")])])])])])
}]

export { render, staticRenderFns }